// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue2-datepicker/index.css
// module id = 660
// module chunks = 0